<header #headerRef class="header" id="header">
  <div
    #headerContentRef
    class="header__content"
    [ngClass]="{
      'header__content--sticky': isSticky,
      'header__content--offset': isOffsetPosition,
      'header__content--invisible': !isVisible,
      'header__content--opened': menuIsOpen || langSwitcherIsOpen
    }"
  >
    <div class="site-content site-content--header">
      <div
        class="main-menu"
        [ngClass]="{ 'main-menu--justify-end': menuIsOpen, 'main-menu--post-booking': isPostBookingPage }"
      >
        <div
          *ngIf="!isPostBookingPage"
          id="main-menu__items"
          data-testid="qa_main-menu-hamburger"
          class="main-menu__hamburger"
        >
          <button
            sparkButton
            background="ghost"
            variant="secondary"
            class="hamburger-menu rounded-xs"
            type="button"
            aria-haspopup="true"
            data-testid="qa_hamburger-menu-toggle"
            [attr.aria-expanded]="menuIsOpen"
            [attr.aria-label]="
              menuIsOpen ? ('header.mobile-menu.close' | translate) : ('header.mobile-menu.open' | translate)
            "
            (click)="toggleMenu()"
            (keydown)="handleKeyDown($event)"
          >
            <span class="hamburger-menu__toggle">
              <span class="hamburger-spinner hamburger-spinner--top"></span>
              <span class="hamburger-spinner hamburger-spinner--middle"></span>
              <span class="hamburger-spinner hamburger-spinner--bottom"></span>
            </span>
          </button>
        </div>
        <!-- header link -->
        <ng-container>
          <!-- we have two links because in the dev environment we shouldn't refresh the whole page using link href -->
          <a
            *ngIf="isDevEnvironment"
            class="header__home-link header__home-link--logo"
            id="qa_header-logo"
            [routerLink]="homePath"
            [ngClass]="{
              'header__home-link--environment': !!currentEnvironment,
              'header__home-link--hidden': isMobile && langSwitcherIsOpen && !menuIsOpen,
              'header__home-link--new-opened-menu': menuIsOpen || langSwitcherIsOpen
            }"
            [attr.data-environment]="currentEnvironment"
            [attr.aria-label]="'Go to home page - Limehome logo'"
          >
            <app-logo />
          </a>
          <a
            *ngIf="!isDevEnvironment"
            class="header__home-link header__home-link--logo"
            id="qa_header-logo"
            [href]="isWordpressEnv ? '/' + currentLang : '/'"
            [ngClass]="{
              'header__home-link--environment': !!currentEnvironment,
              'header__home-link--hidden': isMobile && langSwitcherIsOpen && !menuIsOpen,
              'header__home-link--new-opened-menu': menuIsOpen || langSwitcherIsOpen
            }"
            [attr.data-environment]="currentEnvironment"
            [attr.aria-label]="'Go to home page - Limehome logo'"
          >
            <app-logo />
          </a>
        </ng-container>
        <!-- end of header link -->
        <div class="hamburger-menu__content" [ngClass]="{ 'hamburger-menu__content--no-menu': isCheckoutPage }">
          <app-header-menu
            [isCheckoutPage]="isCheckoutPage"
            [menuIsOpenState]="menuIsOpen"
            [langSwitcherIsOpen]="langSwitcherIsOpen"
            [isPostBookingPage]="isPostBookingPage"
            (toggleMenu)="toggleMenu($event)"
            (openLangSwitch)="openLangSwitch()"
            (closeLangSwitch)="closeLangSwitch()"
          />
        </div>
      </div>
    </div>
  </div>
</header>
